import { toItem } from '../mappers/item';
import { flatten } from 'ramda';
function getNewCursor(res) {
  const regex = new RegExp('page=(\\d+)');
  return res.data.paging.next && regex.exec(res.data.paging.next)[1];
}
export function parseItems(res) {
  const cursor = getNewCursor(res);
  res.data = flatten((res.data.data || []).map(item => toItem(item)));
  res.paging = {
    cursor
  };
  return res;
}